import logo from 'images/logo.svg';
import sunRise from 'images/rise-sunrise-logo.png';
import {usePartnerBranding} from 'branding/usePartnerBranding';
import {CoBrandedLogo} from 'branding/CoBrandedLogo/CoBrandedLogo';
import styles from './RiseHeader.module.css';

type Props = {
  backButton?: boolean;
  onBackClick?: () => void;
  enableCategoryHeader?: boolean;
  category?: string;
  showLogo?: boolean;

  hideCategory?: boolean;
};

const BackArrow = ({className, onClick}: {className: string; onClick: () => void}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.29315 11.2926C6.29306 11.2927 6.29298 11.2928 6.29289 11.2929C6.09482 11.491 5.9972 11.7515 6.00006 12.0111C6.00072 12.0714 6.00681 12.1316 6.01831 12.191C6.05492 12.3801 6.14645 12.5607 6.29289 12.7071L14.2929 20.7071C14.6834 21.0976 15.3166 21.0976 15.7071 20.7071C16.0976 20.3166 16.0976 19.6834 15.7071 19.2929L8.41421 12L15.7071 4.70711C16.0976 4.31658 16.0976 3.68342 15.7071 3.29289C15.3166 2.90237 14.6834 2.90237 14.2929 3.29289L6.29315 11.2926Z"
      />
    </svg>
  );
};

export function RiseHeader({
  backButton = true,
  onBackClick,
  enableCategoryHeader = false,
  category,
  showLogo = false,
  hideCategory = false,
}: Props) {
  const {partner} = usePartnerBranding();
  const mark = partner ? <CoBrandedLogo partner={partner} /> : <img src={logo} alt="Rise" className={styles.logo} />;

  return (
    <div className={`${styles.header}`}>
      <div className={styles.headerLeft}>
        {backButton && onBackClick ? <BackArrow className={styles.backArrow} onClick={onBackClick} /> : null}
      </div>
      <div className={styles.headerCenter}>
        {partner ? (
          <div className={styles.coBrandHeader}>{mark}</div>
        ) : enableCategoryHeader ? (
          <div className={styles.categoryHeader}>
            <div className={styles.ribbon} style={{transform: showLogo ? 'translateY(0px)' : 'translateY(-40px)'}}>
              <img src={sunRise} alt="Rise" className={styles.sunLogo} style={{opacity: showLogo ? 1 : 0}} />
              {mark}
              <div className={`${styles.category}`} style={{opacity: category && !showLogo && !hideCategory ? 1 : 0}}>
                {category}
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.basicHeader}>{mark}</div>
        )}
      </div>
      <div className={styles.headerRight} style={{paddingTop: 5}}></div>
    </div>
  );
}
